import "./loading-screen.css";

const LOADING_LOGO_PATH = "/static/images/logo.png";

export function LoadingScreen() {
  return (
    <div
      className="loading-screen"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="loading-screen__content">
        <img
          className="loading-screen__logo"
          src={LOADING_LOGO_PATH}
          width={156}
          height={54}
          alt=""
          aria-hidden="true"
        />
        <div className="loading-screen__progress" aria-hidden="true">
          <span className="loading-screen__progress-bar" />
        </div>
        <p className="loading-screen__label">Loading Saile…</p>
      </div>
    </div>
  );
}
